import { render, staticRenderFns } from "./JSelectDeviceFacturer.vue?vue&type=template&id=987b40fa&scoped=true&"
import script from "./JSelectDeviceFacturer.vue?vue&type=script&lang=js&"
export * from "./JSelectDeviceFacturer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987b40fa",
  null
  
)

export default component.exports